import { useState } from "react";
import { Card } from "../../../components/card.component";
import { AppRouteUi } from "../../../config/appRoute";
import { ApiUsers } from "../../../core/apis/users";
import { UserForm } from "../../../features/users/addUser.compoenent";
import { useHistory } from "react-router";
import { ActionsUsersTable } from "../../../core/redux/slices/sliceUsersTable";
import { useAppDispatch } from "../../../core/redux/ReduxStore";

export const PageUserAdd = () => {
  const [isLoading, setIsLoading] = useState(false);
  const routeHistory = useHistory();
  const dispatch = useAppDispatch();

  const handleSubmit = async (formData: any) => {
    setIsLoading(true);
    const result = await ApiUsers.Add(formData);

    if (result.isSuccess) {
      dispatch(ActionsUsersTable.goToPage(1));
      routeHistory.push(AppRouteUi.Users.List());
    }

    setIsLoading(false);
  };

  return (
    <Card
      header={
        <div className="row align-items-center justify-content-between">
          <div className="col content-box-title">
            <div className="d-flex align-items-center">
              <div
                onClick={() => {
                  routeHistory.length > 1
                    ? routeHistory.goBack()
                    : routeHistory.push(AppRouteUi.Root);
                }}
                className="pe-2 border-2 border-end click text-green-200"
              >
                <i className="fas fa-arrow-left text-green-200" />
              </div>
              <p className="text-capitalize mb-0 ps-2  text-green-200">
                Add New Users
              </p>
            </div>
            <div className="collapse-icon"></div>
          </div>
        </div>
      }
    >
      <UserForm isLoading={isLoading} handleSubmit={handleSubmit} />
    </Card>
  );
};
